import { useDispatch, useSelector } from "react-redux";
import Planned from "./Planned";
import ConditionValue from '../../../../../../Store/AssetManagement/Condition/ConditionDispatch'
import StatusValue from '../../../../../../Store/AssetManagement/Status/StatusDispatch'
import RequisitionAction from "Store/Component/Requisition/RequisitionAction";
import { formatPrice } from 'utils'
import { useEffect, useState } from "react";
import RequisitionValidation from "../../RequisitionValidation"

const PlannedContainer = (props: any) => {

  const reasonPlanned = props.reason;

  
  const [disposalPrice, setDisposalPrice] = useState();
  const [condition, setCondition] = useState();
  const [status, setStatus] = useState();
  const [assetChangeReason, setAssetChangeReason] = useState<any>();
  const [mileageHour, setMilaegeHour] = useState();
  const [val, setVal] = useState<any>();
  const [isOnBlur, setIsOnBlur] = useState<any>(true);
  const cloneDeep = <T,>(value: T): T => (value === undefined || value === null ? value : JSON.parse(JSON.stringify(value)));
  // dispatch
  const dispatch = useDispatch();
  const dispatchGetCondition = ConditionValue.dispatchGetCondition(dispatch);
  const dispatchGetStatus = StatusValue.dispatchGetStatus(dispatch);

  useEffect(() => {
    dispatchGetCondition();
    dispatchGetStatus();
  }, [])

  useEffect(()=> {
    if(reasonPlanned?.assetError == undefined) {
      props.plannedRef.current[1]?.focus()
    }
  },[reasonPlanned?.assetError])

  useEffect(() => {
    let timeOutId: any;
    if (mileageHour) {
      timeOutId = setTimeout(() => props.plannedRef.current[2]?.focus()
        , 1300);
    }
    return () => clearTimeout(timeOutId);
  }, [mileageHour]);

  

  useEffect(() => {
    let timeOutId: any;
    if (disposalPrice) {
      timeOutId = setTimeout(() => props.plannedRef.current[6]?.focus()
        , 1300);
    }
    return () => clearTimeout(timeOutId);
  }, [disposalPrice])

  ///selectors
  const { reasonList, AssetNumberData, conditionDropDown, statusDropDown, assetValidationError}: any = useSelector((state?: any) => ({
    reasonList: state.RequisitionReducer.reasonList,
    AssetNumberData: state.AssetNumber.assetNumberValue,
    conditionDropDown: state.Condition.conditionDropDown,
    statusDropDown: state.Status.statusDropDown,    
    assetValidationError: state.AssetNumber.assetError
  }));

  ///Modified dropDown values as required
  const conditionDropDownList = conditionDropDown?.map((item: any) =>
    ({ label: item.text, value: item.value })
  );

  const statusDropDownList = statusDropDown?.map((item: any) =>
    ({ label: item.text, value: item.value, text: item.text })
  );


    useEffect(() => {
        if (assetChangeReason && assetValidationError?.assetError?.toString()?.trim()?.length == 0) {
            let reasonListTemp = cloneDeep(reasonList) ?? [];
            for (let i = 0; i < reasonListTemp.length; i++) {
                if (reasonListTemp[i]?.reasonIndex === assetChangeReason?.reasonIndex) {

                    reasonListTemp[i].unitNumber = AssetNumberData?.res?.unitNumber;
                    reasonListTemp[i].description = AssetNumberData?.res?.description;
                    reasonListTemp[i].modelYear = AssetNumberData?.res?.modelYear;
                    reasonListTemp[i].netBookedValue = AssetNumberData?.res?.netBookedValue;
                    reasonListTemp[i].replacementAssetDisposalDate = AssetNumberData?.res?.dateDisposed ?? "";
                    if (reasonListTemp[i].replacementAssetDisposalDate) {
                        reasonListTemp[i].mileageHourMeter = "";
                        reasonListTemp[i].conditionId = 0;
                        reasonListTemp[i].condition = "";
                        reasonListTemp[i].statusId = 0;
                        reasonListTemp[i].status = "";
                        reasonListTemp[i].anticipatedDisposalPrice = "";
                        reasonListTemp[i].mileageHourMeterError = "";
                        reasonListTemp[i].conditionError = "";
                        reasonListTemp[i].anticipatedDisposalPriceError = "";
                        reasonListTemp[i].anticipatedDisposalPriceLengthError = "";
                    }
                    reasonListTemp[i].assetError = assetValidationError?.assetError;
                    if (assetValidationError?.assetError?.length > 0) {
                        reasonListTemp[i].isValidAsset = false;
                    }
                    else {
                        reasonListTemp[i].isValidAsset = true;
                    }
                    let responseReason = RequisitionValidation.ValidateReason({ ...reasonListTemp[i] });
                    reasonListTemp[i] = responseReason;
                    dispatch(RequisitionAction.setIReason(reasonListTemp))
                    setAssetChangeReason([])

                }
            }
        }
    }, [AssetNumberData, assetValidationError?.assetError])



  const onClickPlannedMilaegeHourMeter = (e: any, item: any, reason: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true));
    let valTemp = ({...reason, mileageHourMeter : (item.target.value !== "") ? (item?.target?.value) : null})
        let responseReason = RequisitionValidation.ValidateReason({...valTemp});
        setVal(responseReason)
        setIsOnBlur(false);
    setMilaegeHour(item);
  }

  const milaegeHourMeterFormat = (event: any, reason: any) => {
    const updatedReason = { ...reason, mileageHourMeter: formatPrice(event.target.value, 1) };
    let reasonListTemp = cloneDeep(reasonList) ?? [];
    if (updatedReason?.mileageHourMeter !== "") {
      for (let i = 0; i < reasonListTemp.length; i++) {
        if (reasonListTemp[i]?.reasonIndex === updatedReason?.reasonIndex) {
          reasonListTemp[i] = updatedReason;
          let responseReason = RequisitionValidation.ValidateReason({...reasonListTemp[i]});
          reasonListTemp[i] = responseReason;
          setIsOnBlur(true)
        }
      }
    }
    dispatch(RequisitionAction.setIReason(reasonListTemp))
  };

  const onClickPlannedCondition = (e: any, item: any, reason: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true));
    setCondition(item);
    let reasonListTemp = cloneDeep(reasonList) ?? [];
    
    for (let i = 0; i < reasonListTemp.length; i++) {
      if (reasonListTemp[i]?.reasonIndex === reason?.reasonIndex) {
        reasonListTemp[i].conditionId = item.value;
        reasonListTemp[i].condition = item.label;
        

       

        let responseReason = RequisitionValidation.ValidateReason({ ...reasonListTemp[i] });
        reasonListTemp[i] = responseReason;
      }
    }
    dispatch(RequisitionAction.setIReason(reasonListTemp))
    if (item.label !== 'Select Condition') {
      props.plannedRef.current[4]?.focus()
    }
  }

  const onClickPlannedStatus = (e: any, item: any, reason: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true));
    setStatus(item)
    // setPlannedChangeFlag({ ...plannedChangeFlag, StatusChange: true })
    let reasonListTemp = cloneDeep(reasonList) ?? [];
   
    for (let i = 0; i < reasonListTemp.length; i++) {
      if (reasonListTemp[i]?.reasonIndex === reason?.reasonIndex) {
        reasonListTemp[i].statusId = item.value;
        reasonListTemp[i].status = item.label;
        

        let responseReason = RequisitionValidation.ValidateReason({ ...reasonListTemp[i] });
         reasonListTemp[i] = responseReason;
      }
    }
    dispatch(RequisitionAction.setIReason(reasonListTemp))
    if (item.label !== 'Select Status') {
      props.plannedRef.current[5]?.focus()
    }
  }

  const onClickPlannedComments = (e: any, item: any, reason: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true));
    let valTemp = ({...reason, comments : item.target.value})
        let responseReason = RequisitionValidation.ValidateReason({...valTemp});
        setVal(responseReason)
        setIsOnBlur(false);
  }

  const onClickReason = (e: any, item: any, reason: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true));
    let valTemp = ({...reason, reason : (item.target.value !== "") ? (item?.target?.value) : null})
        let responseReason = RequisitionValidation.ValidateReason({...valTemp});
        setVal(responseReason)
        setIsOnBlur(false);
  }

  const onClickAnticipatedDisposalPrice = (e: any, item: any, reason: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true));
    let valTemp = ({...reason, anticipatedDisposalPrice : (item.target.value !== "") ? (item?.target?.value) : null})
        let responseReason = RequisitionValidation.ValidateReason({...valTemp});
        setVal(responseReason)
        setIsOnBlur(false);
    setDisposalPrice(item)
  }

  const anticipatedDisposalPriceFormat = (event: any, reason: any) => {
    const updatedReason = { ...reason, anticipatedDisposalPrice: formatPrice(event.target.value, 2) };
    let reasonListTemp = cloneDeep(reasonList) ?? [];
    if (updatedReason?.anticipatedDisposalPrice !== "") {
      for (let i = 0; i < reasonListTemp.length; i++) {
        if (reasonListTemp[i]?.reasonIndex === updatedReason?.reasonIndex) {
          reasonListTemp[i] = updatedReason;
          let responseReason = RequisitionValidation.ValidateReason({...reasonListTemp[i]});
          reasonListTemp[i] = responseReason;
          setIsOnBlur(true)
        }
      }
    }
    dispatch(RequisitionAction.setIReason(reasonListTemp))
  };

  const OnBlurOfFields = (reason?: any) => {
    let reasonListTemp = cloneDeep(reasonList) ?? [];
    for (let i = 0; i < reasonListTemp.length; i++) {
      if (reasonListTemp[i]?.reasonIndex === reason?.reasonIndex) {
        reasonListTemp[i] = reason;
        let responseReason = RequisitionValidation.ValidateReason({...reasonListTemp[i]});
        reasonListTemp[i] = responseReason;
      }
    }
    setIsOnBlur(true)
    dispatch(RequisitionAction.setIReason(reasonListTemp));
  }

  return (<>
    <Planned
      AssetNumberData={AssetNumberData}
      reason={isOnBlur ? reasonPlanned : val}
      onClickPlannedMilaegeHourMeter={onClickPlannedMilaegeHourMeter}
      onClickPlannedCondition={onClickPlannedCondition}
      onClickPlannedStatus={onClickPlannedStatus}
      onClickPlannedComments={onClickPlannedComments}
      conditionDropDownList={conditionDropDownList}
      statusDropDownList={statusDropDownList}
      condition={condition}
      status={status}
      milaegeHourMeterFormat={milaegeHourMeterFormat}
      onClickReason={onClickReason}
      onClickAnticipatedDisposalPrice={onClickAnticipatedDisposalPrice}
      anticipatedDisposalPriceFormat={anticipatedDisposalPriceFormat}
      plannedRef={props.plannedRef}
      requestType={props.requestType}
      onChangeQuotePrice={props.onChangeQuotePrice}
      setAssetChangeReason = {setAssetChangeReason}
      assetChangeReason = {assetChangeReason}
      OnBlurOfFields = {OnBlurOfFields}
    />
  </>)
}

export default PlannedContainer;
